import React from 'react';
import { useTranslation } from 'react-i18next';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import PageHeader from '../../../shared/ui/page-header/page-header.jsx';

function formatDate(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return '-';
  }

  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? raw : date.toLocaleString();
}

function ComplianceSarPageView({
  items,
  isLoading,
  isSubmitting,
  activeUid,
  form,
  error,
  success,
  onFormChange,
  submitCreate,
  complete,
}) {
  const { t } = useTranslation();

  return (
    <div>
      <FloatingAlerts error={error} success={success} />
      <PageHeader title={t('complianceSar.title')} subtitle={t('complianceSar.subtitle')} />

      <div className="row g-3">
        <div className="col-xl-4">
          <div className="card card-body">
            <h5 className="mb-3">{t('complianceSar.createRequest')}</h5>
            <form onSubmit={submitCreate}>
              <div className="mb-3">
                <label className="form-label">{t('complianceSar.labelProfileUid')}</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.profileUid}
                  onChange={(event) => onFormChange('profileUid', event.target.value)}
                  disabled={isSubmitting}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">{t('complianceSar.labelNotes')}</label>
                <textarea
                  className="form-control"
                  rows={4}
                  value={form.notes}
                  onChange={(event) => onFormChange('notes', event.target.value)}
                  disabled={isSubmitting}
                />
              </div>
              <div className="d-flex justify-content-end">
                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                  {isSubmitting ? t('complianceSar.creating') : t('complianceSar.createSarButton')}
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="col-xl-8">
          <div className="card card-body">
            {isLoading ? <div className="text-muted">{t('complianceSar.loading')}</div> : null}
            {!isLoading && items.length === 0 ? <div className="text-muted">{t('complianceSar.noRequests')}</div> : null}
            {!isLoading && items.length > 0 ? (
              <div className="table-responsive">
                <table className="table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>{t('complianceSar.colProfileUid')}</th>
                      <th>{t('complianceSar.colStatus')}</th>
                      <th>{t('complianceSar.colRequested')}</th>
                      <th>{t('complianceSar.colDeadline')}</th>
                      <th>{t('complianceSar.colCompleted')}</th>
                      <th>{t('complianceSar.colRequestedBy')}</th>
                      <th>{t('complianceSar.colNotes')}</th>
                      <th className="text-end">{t('complianceSar.colAction')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item) => (
                      <tr key={item.uid || `${item.profileUid}-${item.requestedAt}`}>
                        <td className="text-break">{item.profileUid || '-'}</td>
                        <td>
                          <span className={`badge rounded-pill fw-semibold text-uppercase ${String(item.status || '').trim().toLowerCase() === 'completed' ? 'bg-success-subtle text-success' : 'bg-warning-subtle text-warning'}`}>
                            {item.status || '-'}
                          </span>
                        </td>
                        <td>{formatDate(item.requestedAt)}</td>
                        <td>{formatDate(item.deadlineAt)}</td>
                        <td>{formatDate(item.completedAt)}</td>
                        <td>{item.requestedByEmail || '-'}</td>
                        <td className="text-break">{item.notes || '-'}</td>
                        <td className="text-end">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            disabled={activeUid === item.uid || String(item.status || '').trim().toLowerCase() === 'completed'}
                            onClick={() => complete(item.uid)}
                          >
                            {activeUid === item.uid ? t('complianceSar.completing') : t('complianceSar.completeButton')}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComplianceSarPageView;
